import React, { useEffect, useState } from 'react';
import { API_URL } from '../../../constants/api';
import { getToken, decodeToken } from '../../../utils/TokenUtils';

const TrialBalance = ({ report,link,value }) => {
  const [trialBalanceData, setTrialBalanceData] = useState([]);
  const token = getToken();
  const companyName = decodeToken(token, 'companyName');
  const companyBanner = decodeToken(token, 'banner');
 const [currentDate,setCurrentDate] = useState();
  useEffect(() => {
    console.log("Trial Balance Data: ",report);
    setTrialBalanceData(report);
    const formattedDate = new Intl.DateTimeFormat('en-GB').format(new Date(value.date));
    setCurrentDate(formattedDate);
    console.log("curdate: ",formattedDate);
  }, [report]);

  const parseAmount = (amount) => {
    if (typeof amount === 'string') {
      return parseFloat(amount.replace(/[^0-9.-]+/g, '')) || 0;
    }
    return amount || 0;
  };

  const formatAmount = (amount) => {
    return `$${amount?.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  const totalDebit = trialBalanceData.reduce(
    (total, item) => total + parseAmount(item.DR),
    0
  );

  const totalCredit = trialBalanceData.reduce(
    (total, item) => total + parseAmount(item.CR),
    0
  );

  
  return (
    <div style={styles.container}>
      <div style={styles.headerSection}>
        <div style={styles.bannerHeader}>
          <img src={`${API_URL}/${companyBanner}`} alt="Company Banner" style={styles.logo} />
        </div>
        <h1 style={styles.companyName}>{companyName}</h1>
        <p style={styles.date}>Trial Balance as of {currentDate}</p>
      </div>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.header}>Account</th>
            <th style={styles.header}>Debit ($)</th>
            <th style={styles.header}>Credit ($)</th>
          </tr>
        </thead>
        <tbody>
          {trialBalanceData.map((item, index) => (
            <tr key={index}>
              <td style={styles.rowLabel}>{item.Account}</td>
              <td style={styles.rowAmount}>
                {item.DR ? formatAmount(parseAmount(item.DR)) : ''}
              </td>
              <td style={styles.rowAmount}>
                {item.CR ? formatAmount(parseAmount(item.CR)) : ''}
              </td>
            </tr>
          ))}
          <tr>
            <td style={styles.totalLabel}>Total</td>
            <td style={styles.rowAmount}><strong>{formatAmount(totalDebit)}</strong></td>
            <td style={styles.rowAmount}><strong>{formatAmount(totalCredit)}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const styles = {
  container: {
    width: '90%',
    margin: 'auto',
    paddingTop: '20px',
    fontFamily: 'Arial, sans-serif',
    fontSize: '14px',
    color: '#333',
  },
  headerSection: {
    textAlign: 'center',
    marginBottom: '30px',
  },
  bannerHeader: {
    marginBottom: '10px',
  },
  logo: {
    width: '90%',
    height: '150px',
    objectFit: 'fit',
  },
  companyName: {
    fontSize: '26px',
    fontWeight: 'bold',
    margin: '10px 0 5px',
  },
  date: {
    fontSize: '17px',
    fontWeight:"bold",
    color: '#777',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
  },
  header: {
    padding: '10px',
    textAlign: 'left',
    border: '1px solid #ccc',
    backgroundColor: '#f4f4f4',
    fontWeight: 'bold',
  },
  rowLabel: {
    padding: '10px',
    border: '1px solid #ddd',
    fontSize: '16px',
    fontWeight: '500',
  },
  rowAmount: {
    padding: '10px',
    border: '1px solid #ddd',
    textAlign: 'right',
    fontSize: '16px',
    fontWeight: '600',
    color: '#222',
  },
  totalLabel: {
    padding: '10px',
    fontWeight: 'bold',
    border: '1px solid #ccc',
    backgroundColor: '#e2e2e2',
    fontSize: '16px',
  },
};

export default TrialBalance;
